var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#60666C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_480_65122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1997 27.7334H41.4663C42.7997 27.7334 43.733 28.8001 43.733 30.0001V39.2001C43.733 41.6001 42.7997 44.0001 41.0663 45.7334C39.333 47.4667 37.0663 48.4001 34.533 48.4001C32.133 48.4001 29.733 47.4667 27.9997 45.7334C26.2663 44.0001 25.333 41.7334 25.333 39.2001V30.0001C25.333 28.6667 26.3997 27.7334 27.5997 27.7334H29.8663",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 25.3333V29.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2002 25.3333V29.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0668 41.8667C52.0216 41.8667 52.9372 41.4875 53.6124 40.8123C54.2875 40.1372 54.6668 39.2215 54.6668 38.2667C54.6668 37.312 54.2875 36.3963 53.6124 35.7212C52.9372 35.046 52.0216 34.6667 51.0668 34.6667C50.112 34.6667 49.1963 35.046 48.5212 35.7212C47.8461 36.3963 47.4668 37.312 47.4668 38.2667C47.4668 39.2215 47.8461 40.1372 48.5212 40.8123C49.1963 41.4875 50.112 41.8667 51.0668 41.8667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2003 41.8667V46.4C51.2003 50.9334 47.4669 54.6667 42.9336 54.6667C39.0669 54.6667 35.8669 52.1334 34.9336 48.6667V48.392",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8671 37.8667C35.2004 37.2 34.1338 37.2 33.4671 37.8667L30.8004 40.5334C29.7338 41.6 30.5338 43.3334 32.0004 43.3334H37.3338C38.8004 43.3334 39.6004 41.4667 38.5338 40.5334L35.8671 37.8667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6671 34.9334C29.5257 34.9334 29.39 34.8772 29.29 34.7772C29.19 34.6771 29.1338 34.5415 29.1338 34.4C29.1338 34.2586 29.19 34.1229 29.29 34.0229C29.39 33.9229 29.5257 33.8667 29.6671 33.8667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.667 34.9334C29.8084 34.9334 29.9441 34.8772 30.0441 34.7772C30.1441 34.6771 30.2003 34.5415 30.2003 34.4C30.2003 34.2586 30.1441 34.1229 30.0441 34.0229C29.9441 33.9229 29.8084 33.8667 29.667 33.8667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6671 34.9334C39.5257 34.9334 39.39 34.8772 39.29 34.7772C39.19 34.6771 39.1338 34.5415 39.1338 34.4C39.1338 34.2586 39.19 34.1229 39.29 34.0229C39.39 33.9229 39.5257 33.8667 39.6671 33.8667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.667 34.9334C39.8084 34.9334 39.9441 34.8772 40.0441 34.7772C40.1441 34.6771 40.2003 34.5415 40.2003 34.4C40.2003 34.2586 40.1441 34.1229 40.0441 34.0229C39.9441 33.9229 39.8084 33.8667 39.667 33.8667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6671 32.9334C34.5257 32.9334 34.39 32.8772 34.29 32.7772C34.19 32.6771 34.1338 32.5415 34.1338 32.4C34.1338 32.2586 34.19 32.1229 34.29 32.0229C34.39 31.9229 34.5257 31.8667 34.6671 31.8667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.667 32.9334C34.8084 32.9334 34.9441 32.8772 35.0441 32.7772C35.1441 32.6771 35.2003 32.5415 35.2003 32.4C35.2003 32.2586 35.1441 32.1229 35.0441 32.0229C34.9441 31.9229 34.8084 31.8667 34.667 31.8667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_480_65122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImage);
export default __webpack_public_path__ + "static/media/placeholder-image.cf983e09d2a6b6e4e21c06d1c5115c79.svg";
export { ForwardRef as ReactComponent };